export default "__VITE_ASSET__CIV1rN5x__"